import { PlaybookTemplate } from './index';

export const enrichContactsTemplate: PlaybookTemplate = {
  id: 'enrich-contacts',
  name: 'Contact Enrichment',
  description:
    'Maintain a living CRM by scanning Gmail and Calendar to keep Contact entities enriched with interaction history, topics, signals, and suggested reach-out timing.',
  category: 'crm',
  defaultAllowedTools: [
    'contacts_discover',
    'contacts_enrich',
    'contacts_find',
    'contacts_update',
    'entity_find',
    'entity_read',
    'mail_searchMessages',
  ],
  defaultTriggerEntityTypes: [],
  prompt: `# Contact Enrichment

Maintain a living CRM by scanning connected integrations and keeping Contact entities
up to date with interaction history, topics, signals, and suggested reach-out timing.

## Modes

Run in one of three modes based on what the user says:

### Mode: all (default)

1. Use \`contacts_discover\` to scan recent Gmail threads and Calendar events for
   contacts not yet in the system. For each new contact found, create a stub.
2. Use \`contacts_find\` to retrieve all existing contacts.
3. For each contact whose \`lastEnrichedAt\` is older than 24 hours (or never set),
   run \`contacts_enrich\` to pull in latest interactions, extract topics and signals,
   and update \`nextReachOutAt\`.
4. Summarize: contacts updated, new contacts discovered, contacts with no new activity.

### Mode: stale

1. Use \`contacts_find\` to get all contacts.
2. For each contact, compare \`lastInteraction.at\` against their tier cadence:
   - close: flag if > 14 days
   - regular: flag if > 30 days
   - archived: skip
3. Present a relationship health report grouped by: Needs Attention / Approaching / Healthy.
4. For overdue contacts, suggest a specific touchpoint based on their recent topics.
5. Ask if the user wants to draft any of those outreach messages.

### Mode: <contact name or email>

1. Use \`contacts_find\` with the name/email to locate the contact entity.
2. Run \`contacts_enrich\` on that specific contact.
3. Check if any upcoming Calendar events include them.
4. Present what was updated (topics, signals, last interaction, new reach-out date).
5. If a meeting is upcoming, offer to prepare a brief meeting prep note.

## Guidelines

- Only update fields that have genuinely new information — don't overwrite with noise.
- Tier assignments reflect actual relationship importance, not aspiration.
- Stale alerts are suggestions, not demands.
- Never surface private/sensitive content in contact notes.`,
};
